// extracted by mini-css-extract-plugin
export default {"wrapper":"iA-z","viewport":"jA-z","container":"kA-z","slide":"lA-z"};